import type { PaginationMeta } from '../../api/admin';

interface PaginationControlsProps {
  pagination: PaginationMeta;
  onPageChange: (page: number) => void;
}

export default function PaginationControls({ pagination, onPageChange }: PaginationControlsProps) {
  const { page, totalPages, total } = pagination;
  if (total <= pagination.pageSize) return null;

  return (
    <div className="flex items-center justify-between gap-3 pt-4">
      <p className="text-xs text-zinc-500">
        Page {page} of {totalPages} · {total} total
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="h-8 px-3 rounded-lg border border-zinc-700 text-zinc-300 text-xs disabled:opacity-40"
        >
          Previous
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="h-8 px-3 rounded-lg border border-zinc-700 text-zinc-300 text-xs disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}
